import * as React from 'react';
import {
    Skeleton,
} from '@chakra-ui/react';

const ComponentTileSkeleton = (): JSX.Element | null => {

    return (

        <Skeleton
            width="100%"
            height="200px"
        />

    );

};

export default ComponentTileSkeleton;
